var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { projectRings } from "../geotools";
import { CombinedPolylineSymbol } from "../symbols/CombinedPolylineSymbol";
import { Polyline } from "./Polyline";
/**
 * A line or a set of geographical lines.
 * @alias sGis.feature.CombinedPolyline
 */
export class CombinedPolyline extends Polyline {
    constructor(rings, _a = {}) {
        var { symbol = new CombinedPolylineSymbol() } = _a, params = __rest(_a, ["symbol"]);
        super(rings, Object.assign({ symbol }, params));
        this.isEnclosed = false;
        this.values = [];
    }
    /**
     * Returns a copy of the feature. Only generic properties are copied.
     */
    clone() {
        return new CombinedPolyline(this.rings, { crs: this.crs, symbol: this.originalSymbol });
    }
    projectTo(crs) {
        let projected = projectRings(this.rings, this.crs, crs);
        return new CombinedPolyline(projected, { crs: this.crs, symbol: this.symbol, persistOnMap: this.persistOnMap });
    }
}
